var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 30,
      height: 30,
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M896 102.4h-460.8C392.8576 102.4 358.4 136.8576 358.4 179.2v153.6a25.6 25.6 0 0 0 51.2 0v-153.6a25.6 25.6 0 0 1 25.6-25.6h387.2768l-196.7104 84.3264C590.6944 252.9792 563.2 294.656 563.2 332.8V819.2H435.2a25.6 25.6 0 0 1-25.6-25.6v-153.6a25.6 25.6 0 0 0-51.2 0v153.6c0 42.3424 34.4576 76.8 76.8 76.8H563.2v76.8c0 22.1696 9.216 41.0112 25.344 51.6096 8.9088 5.8368 19.2512 8.8064 30.1568 8.8064 8.8576 0 18.1248-1.9456 27.2384-5.8368l264.2944-113.2544C945.3056 873.472 972.8 831.7952 972.8 793.6v-614.4c0-42.3424-34.4576-76.8-76.8-76.8z m25.6 691.2c0 17.9712-15.0528 40.7552-31.5392 47.8208l-264.2944 113.2544c-4.9152 2.0992-8.1408 1.9456-9.0624 1.3824S614.4 952.5248 614.4 947.2v-614.4c0-17.9712 15.0528-40.7552 31.5392-47.8208l273.0496-117.0432A25.1392 25.1392 0 0 1 921.6 179.2v614.4z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M427.7248 468.2752l-153.6-153.6a25.6 25.6 0 0 0-36.1984 36.1984l109.8752 109.8752H25.6a25.6 25.6 0 0 0 0 51.2h322.2016l-109.8752 109.8752a25.6 25.6 0 0 0 36.2496 36.1984l153.6-153.6a25.6 25.6 0 0 0 0-36.1984z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterService);
export default __webpack_public_path__ + "static/media/enter-service.e83856d3b1651f32eca5777f97a27d61.svg";
export { ForwardRef as ReactComponent };